import { Injectable } from '@angular/core';
import { FilesService } from '../../services/files/files.service';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { FilesActionsTypes } from '../../actions/files/files.actions';
import { tap } from 'rxjs/operators';
import { NotificationService } from '../../services/notification/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class FilesEffects {
  @Effect({ dispatch: false })
  public uploadFile() {
    return this.actions.pipe(
      ofType(FilesActionsTypes.UPLOAD_FILE),
      tap((action: any) => {
        const progresses = this.fileService.uploadFiles(action.files);
        progresses.forEach(progress => {
          progress.subscribe(
            item => {
              item.file.isLoaded = true;
              item.file.id = item.result.body.node_id;
              item.file.path = item.result.body.path;
              item.file.result = item.result.body;
            },
            error => {
              if (error.error.type && error.error.type === 'error' || error.status === 413 || error.message.includes('Unknown Error')) {
                this.notificationService.showErrorNotification(this.translateService.instant('The file is too big. Please select a smaller file.'));
              } else {
                this.notificationService.showErrorNotification(error.error.errorMessage ? error.error.errorMessage : error.message);
              }
            }
          );
        });
      })
    );
  }

  @Effect({ dispatch: false })
  public getDownloadLink() {
    return this.actions.pipe(
      ofType(FilesActionsTypes.DOWNLOAD_FILE),
      tap((action: any) => {
        this.fileService.saveDownloadLink(action.relatedId).subscribe(file => {
          this.fileService.downloadFile(file.url);
        });
      })
    );
  }

  @Effect({ dispatch: false })
  public deleteFile() {
    return this.actions.pipe(
      ofType(FilesActionsTypes.DELETE_FILE),
      tap((action: any) => {
        this.fileService.deleteFile(action.filenames);
      })
    );
  }

  @Effect({ dispatch: false })
  public deleteTempFile() {
    return this.actions.pipe(
      ofType(FilesActionsTypes.DELETE_TEMP_FILE),
      tap((action: any) => {
        this.fileService.deleteTempFile(action.fileIds);
      })
    );
  }

  constructor(
    private actions: Actions,
    private fileService: FilesService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {}
}
